import React, { useEffect, useState } from "react";

import { toast } from "react-hot-toast";
import { Card, Col, Form, Row } from "react-bootstrap";
import Progress from "react-progress-2";
import CardHeader from "../../components/common/CardHeader";
import CardBody from "../../components/common/CardBody";
import EditButton from "../../components/common/EditButton";
import ViewButton from "../../components/common/ViewButton";
import DeleteButton from "../../components/common/DeleteButton";
import ProductImage from "../../components/common/ProductImage";
import LinkButton from "../../components/common/LinkButton";
import { privateApi } from "../../api";

const UserList = () => {
      const [users, setUsers] = useState([]);
      const [loading, setLoading] = useState(false);
      const [totalUsers, setTotalUsers] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const [limit, setLimit] = useState(10);
      const [search, setSearch] = useState("");

      const loadData = async () => {
            setLoading(true);
            await privateApi
                  .get(`/dashboard/users?limit=${limit}&search=${search}`)
                  .then((response) => {
                        if (response.data.result == "success") {
                              setUsers(response.data.users);
                              setTotalUsers(response.data.totalUsers);
                              setPerPages(response.data.itemsCountPerPage);
                              setCurrentPage(response.data.currentPage);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, [limit, search]);

      async function getData(pageNumber = 1) {
            window.scrollTo(0, 0);
            setLoading(true);
            Progress.show();
            const url = `/dashboard/users?page=${pageNumber}`;
            await privateApi(url)
                  .then((response) => {
                        setUsers(response.data.users);
                        setTotalUsers(response.data.totalUsers);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      }

      const handleStatus = async (user) => {
            await privateApi
                  .post(`/dashboard/users/${user.id}/status`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (user) => {
            const response = await privateApi
                  .delete(`/dashboard/users/${user.id}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setUsers((users) =>
                                    users.filter((item) => item.id !== user.id)
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="User List">
                                          <LinkButton
                                                title="Add New"
                                                link="/dashboard/users/create"
                                          />
                                    </CardHeader>
                                    <CardBody
                                          setLimit={setLimit}
                                          setSearch={setSearch}
                                          totalItems={totalUsers}
                                          currentPage={currentPage}
                                          perPages={perPages}
                                          getData={getData}
                                    >
                                          <thead>
                                                <tr>
                                                      <th
                                                            className="text-center"
                                                            width="80px"
                                                      >
                                                            #
                                                      </th>
                                                      <th>User Name</th>
                                                      <th>Email</th>
                                                      <th>Date</th>

                                                      <th width="120px">
                                                            Status
                                                      </th>
                                                      <th width="120px">
                                                            Action
                                                      </th>
                                                </tr>
                                          </thead>
                                          <tbody>
                                                {!loading ? (
                                                      users.length > 0 ? (
                                                            users.map(
                                                                  (
                                                                        user,
                                                                        index
                                                                  ) => (
                                                                        <>
                                                                              <tr
                                                                                    key={
                                                                                          index
                                                                                    }
                                                                              >
                                                                                    <td className="text-center">
                                                                                          {
                                                                                                user.index
                                                                                          }
                                                                                    </td>
                                                                                    <td>
                                                                                          <ProductImage
                                                                                                title={
                                                                                                      user.name
                                                                                                }
                                                                                                image={
                                                                                                      user.photo
                                                                                                }
                                                                                                category={
                                                                                                      user.role
                                                                                                }
                                                                                          />
                                                                                    </td>
                                                                                    <td>
                                                                                          <ProductImage
                                                                                                title={
                                                                                                      user.email
                                                                                                }
                                                                                                category={`Phone: ${user.phone_number}`}
                                                                                          />
                                                                                    </td>
                                                                                    <td>
                                                                                          {
                                                                                                user.date
                                                                                          }
                                                                                    </td>
                                                                                    <td>
                                                                                          <Form.Check
                                                                                                type="switch"
                                                                                                id="custom-switch"
                                                                                                defaultChecked={
                                                                                                      user.status ===
                                                                                                      1
                                                                                                            ? true
                                                                                                            : false
                                                                                                }
                                                                                                onClick={() =>
                                                                                                      handleStatus(
                                                                                                            user
                                                                                                      )
                                                                                                }
                                                                                          />
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                          <EditButton
                                                                                                link={`/dashboard/users/${user.id}/edit`}
                                                                                          />
                                                                                          <ViewButton
                                                                                                link={`/dashboard/users/${user.id}/show`}
                                                                                          />
                                                                                          <DeleteButton
                                                                                                item={
                                                                                                      user
                                                                                                }
                                                                                                loading={
                                                                                                      loading
                                                                                                }
                                                                                                setLoading={
                                                                                                      setLoading
                                                                                                }
                                                                                                handleDelete={
                                                                                                      handleDelete
                                                                                                }
                                                                                          />
                                                                                    </td>
                                                                              </tr>
                                                                        </>
                                                                  )
                                                            )
                                                      ) : (
                                                            <>
                                                                  <tr>
                                                                        <td
                                                                              colSpan="6"
                                                                              className="text-center"
                                                                        >
                                                                              No
                                                                              User
                                                                              Found.
                                                                        </td>
                                                                  </tr>
                                                            </>
                                                      )
                                                ) : (
                                                      <>
                                                            <tr>
                                                                  <td
                                                                        colSpan="6"
                                                                        className="text-center"
                                                                  >
                                                                        Loading...
                                                                  </td>
                                                            </tr>
                                                      </>
                                                )}
                                          </tbody>
                                    </CardBody>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default UserList;
